import { Grid } from "@material-ui/core";
import React from "react";
import { useParams } from "react-router-dom";
import StudentProfileContent from "../../components/StudentProfile/StudentProfileContent";

export default function StudentProfile() {
    const { id } = useParams();
    return (
        <div className="p-2 p-lg-3">
            <Grid container spacing={0}>
                <Grid item xs={12}>
                    <StudentProfileContent id={id} />
                </Grid>
            </Grid>
        </div>
    );
}
